var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetergentReservoirOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OFF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    d: "M.66,3.2s-.22.62,2.91,1.41A57.842,57.842,0,0,0,16.46,5.73a76.815,76.815,0,0,0,10.2-.76s4.33-.72,4.65-1.71c0,0-.21-.61-2.4-.99A69.825,69.825,0,0,0,16,.87,52.127,52.127,0,0,0,2.69,2.25S1,2.65.66,3.2Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9856",
    "data-name": "Group 9856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    d: "M.33,3.2V27.05c0,2,7.02,3.62,15.67,3.62s15.67-1.62,15.67-3.62V3.2",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    d: "M16,31C8.24,31,0,29.62,0,27.05V3.2H.66V27.05c0,1.56,6.3,3.29,15.34,3.29s15.34-1.73,15.34-3.29V3.2H32V27.05C32,29.62,23.76,31,16,31Z",
    fill: "#404041"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9860",
    "data-name": "Group 9860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9857",
    "data-name": "Group 9857"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_346",
    "data-name": "Ellipse 346",
    cx: 15.67,
    cy: 2.87,
    rx: 15.67,
    ry: 2.87,
    transform: "translate(0.33 0.33)",
    fill: "#2f323a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    "data-name": "Path 3894",
    d: "M16,6.4C9.57,6.4,0,5.55,0,3.2S9.57,0,16,0,32,.85,32,3.2,22.43,6.4,16,6.4ZM16,.66C6.49.66.66,2.14.66,3.2S6.49,5.74,16,5.74,31.34,4.26,31.34,3.2,25.51.66,16,.66Z",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9859",
    "data-name": "Group 9859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9858",
    "data-name": "Group 9858",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_347",
    "data-name": "Ellipse 347",
    cx: 15.67,
    cy: 2.87,
    rx: 15.67,
    ry: 2.87,
    transform: "translate(0.33 1.76)",
    fill: "#8b90a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M16,8.05C10.39,8.05-.22,7.34-.22,4.63S10.39,1.21,16,1.21s16.22.72,16.22,3.42S21.61,8.05,16,8.05Zm0-5.74C6.29,2.31.99,3.82.88,4.63,1,5.44,6.29,6.95,16,6.95S31,5.44,31.12,4.63C31,3.82,25.7,2.31,16,2.31Z",
    fill: "#8b90a0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetergentReservoirOff);
export default __webpack_public_path__ + "static/media/detergent_reservoir_off.c0a4503dee049e592b0b923d59303e19.svg";
export { ForwardRef as ReactComponent };